const applictionConstants = {
  // The format for actions is {NOUN}_{VERB}, so INPUT_UPDATED, CONTENT_UPDATED, etc.
  SPA_ENABLED: "SPA_ENABLED",
  SYSTEM_ERROR_OCCURED: "SYSTEM_ERROR_OCCURED",
  SYSTEM_ERROR_CLEARED: "SYSTEM_ERROR_CLEARED",
  SET_REDIRECT_URL: "SET_REDIRECT_URL",
  CLEAR_REDIRECT_URL: "CLEAR_REDIRECT_URL",
  CSRF_TOKEN_SET: "CSRF_TOKEN_SET",
  SET_PREVIOUS_HISTORY: "SET_PREVIOUS_HISTORY",
}

export default applictionConstants
